export const companyOptions = [
    { value: 'all', label: 'All' },
    { value: 'tesla', label: 'Tesla' },
    { value: 'google', label: 'Google' },
    { value: 'amd', label: 'AMD Southwest Parkway' },
    { value: 'amd metcenter', label: 'AMD MetCenter'},
    { value: 'cirrus logic', label: 'Cirrus Logic'},
    // { value: 'samsung', label: 'Samsung'},
    { value: 'spacex', label: 'SpaceX'},
    { value: 'boring company', label: 'Boring Company'},
    { value: 'nxp semiconductors', label: 'NXP Semiconductors'}
];
